import React, { useCallback, useState } from 'react';

import delv from 'dlv';

import { MenuObject } from '@rbi-ctg/menu';
import LoadingAnimation from 'components/loading-animation';
import LoadingContainer from 'components/loading-animation/loading-container';
import PickerBackgroundImage from 'pages/menu-content/picker-background-image';

import Guide from './guide';
import Hero from './hero';
import LayoutContainer from './layout-container';
import Wizard from './wizard';
import { WizardProvider } from './wizard-provider';

interface IMenuOrderWizardProps {
  data: MenuObject;
  loading: boolean;
  enableDynamicPickerImages?: boolean;
}

const MenuOrderWizard: React.FC<IMenuOrderWizardProps> = props => {
  const [productImage, setProductImage] = useState(props?.data?.image);

  const handleSelectProduct = useCallback(
    (selectedProduct: MenuObject) => {
      if (!props?.enableDynamicPickerImages) {
        return;
      }

      setProductImage(selectedProduct?.image || props?.data?.image);
    },
    [props]
  );

  return (
    <WizardProvider>
      <LayoutContainer>
        {props.loading ? (
          <LoadingContainer>
            <LoadingAnimation fillColor={Styles.color.primary} />
          </LoadingContainer>
        ) : (
          <>
            <PickerBackgroundImage />
            <Hero image={productImage} alt={delv(props, 'data.imageDescription.locale')} />
            <Guide>
              <Wizard onSelectProduct={handleSelectProduct} {...props} />
            </Guide>
          </>
        )}
      </LayoutContainer>
    </WizardProvider>
  );
};

export default MenuOrderWizard;
